<div class="row container_fieldset">
  <div class="col-sm-12">
    <fieldset class="form-group">
      <legend>Mediazione</legend>
      <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
           [labelInput]="'Modalit&agrave; di partecipazione'"
           [valueInput]="ctxBodyFascicolo.fascicolo.modalitaPartecipazione ? ctxBodyFascicolo.fascicolo.modalitaPartecipazione.label : ''"></div>
      <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
           [labelInput]="'Organismo di mediazione'"
           [valueInput]="ctxBodyFascicolo.fascicolo.organismoMediazione"></div>
      <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
           [labelInput]="'Sede incontro'"
           [valueInput]="ctxBodyFascicolo.fascicolo.sedeIncontro"></div>
    </fieldset>
  </div>
</div>
<div class="row">
  <div class="col-sm-12 bloccodati">
    <p>
      <label class="col-sm-12">Note</label>
      <span class="longtext">{{ ctxBodyFascicolo.fascicolo.note }}</span>
    </p>
  </div>
</div>
